import React from 'react';
import { Row } from 'react-bootstrap';
const TechnicalTemplatesControls = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default TechnicalTemplatesControls;